import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { homeworkList } from '../../../../actions/homeworkActions';
import { get, isEmpty } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { formatDateAndTime } from '../../../../api/dateFormat';
import { usePagination } from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';
import PopUpModal from '../../../../components/PopUpModal/index';
import HomeworkDetails from '../HomeWorkDetails/index';
import './styles.scss';
import NoData from '../../../../components/NoData';
import PageHeading from '../../../../components/PageHeading';
import { Link } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function HomeWorkListTable() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const childRef = useRef();

  const [pageNo, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [UniqueCode, setUniqueCode] = React.useState('');
  const [isFetching, setIsFetching] = useState(false);
  const columns = [
    { id: 'subject', label: 'Subject', minWidth: 150 },
    { id: 'date', label: 'Date', minWidth: 150 },
    { id: 'action', label: 'Actions', minWidth: 70 },
  ];

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );

  useEffect(() => {
    setIsFetching(true);
    homeworkList(jwtToken, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const homeworkListData = useSelector((state) =>
    get(state, 'homeworkReducer.data', {})
  );

  const errorMessage = useSelector((state) =>
    get(state, 'homeworkReducer.errorMessage', '')
  );

  function createData(subject, date, action) {
    return { subject, date, action };
  }

  const populateHomeworkList = () => {
    let rowData = [];
    homeworkListData.length !== 0 &&
      !isEmpty(homeworkListData) &&
      homeworkListData.map((row) => {
        rowData.push(
          createData(row.HomeWorkTitle, formatDateAndTime(row.OCHDate), 'View')
        );
      });
    return rowData;
  };

  const rows = isFetching? [1,1,1,1,1,1,1,1]:populateHomeworkList();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const defaultLabelDisplayedRows = () => {
    let count = rows.length;
    const from = count === 0 ? 0 : pageNo * rowsPerPage + 1;
    const to =
      count !== -1
        ? Math.min(count, (pageNo + 1) * rowsPerPage)
        : (pageNo + 1) * rowsPerPage;
    return `Showing ${from} to ${to} of ${
      count !== -1 ? count : `more than ${to}`
    } entries `;
  };
  const totalPages =
    rows.length === 0 || rowsPerPage === 0
      ? 0
      : Math.ceil(rows.length / rowsPerPage);

  const ActionsComponent = () => {
    return CustomPagination(totalPages);
  };

  const setPageValue = (page, type) => {
    const totalPages =
      rows.length === 0 || rowsPerPage === 0
        ? 0
        : Math.ceil(rows.length / rowsPerPage);
    const currentPage = pageNo;
    if (type === 'next') {
      currentPage !== totalPages - 1
        ? setPage(currentPage + 1)
        : setPage(currentPage);
    } else if (type === 'previous') {
      currentPage !== 0 ? setPage(currentPage - 1) : setPage(currentPage);
    } else {
      setPage(page - 1);
    }
  };

  const fetchHomeWorkDetails = () => {
    const body = <HomeworkDetails UniqueCode={UniqueCode} />;
    return body;
  };

  const header = <div> Homework </div>;

  const handleButtonDisable = (type) => {
    let disable = false;
    if (rows.length <= 10) {
      disable = true;
    } else if (type === 'previous' && pageNo === 0) {
      disable = true;
    } else if (type === 'next' && pageNo === totalPages - 1) {
      disable = true;
    }
    return disable;
  };

  const CustomPagination = (totalPages) => {
    const { items } = usePagination({
      count: totalPages,
    });
    return (
      <nav>
        <ul className="table-pagination">
          {items.map(({ page, type, ...item }, index) => {
            let children = null;
            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              children = '…';
            } else if (type === 'page') {
              children = (
                <button
                  className={
                    pageNo + 1 === index
                      ? 'pagination-active-buttons'
                      : 'pagination-inactive-buttons'
                  }
                  key={`button ${page}`}
                  type="button"
                  {...item}
                >
                  {page}
                </button>
              );
            } else {
              children = (
                <button
                  className="pagination-main-buttons"
                  type="button"
                  key={`buttons ${page}`}
                  disabled={handleButtonDisable(type)}
                >
                  {type === 'previous' ? 'Previous' : 'Next'}
                </button>
              );
            }
            return (
              <li key={index} onClick={() => setPageValue(page, type, index)}>
                {children}
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Homework" />
      {isFetching || (homeworkListData.length !== 0 && !isEmpty(homeworkListData)) ? (
        <React.Fragment>
          <TableContainer className="table-container">
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      className="table-header"
                      key={index}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(
                    pageNo * rowsPerPage,
                    pageNo * rowsPerPage + rowsPerPage
                  )
                  .map((row, index) => {
                    let UniqueCode = homeworkListData[index]
                      ? homeworkListData[index].UniqueCode
                      : null;
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={`row ${index}`}
                      >
                        {columns.map((column, index) => {
                          const value = row[column.id];
                          return column.id === 'action' ? (
                            <TableCell
                              key={`column ${index}`}
                              align={column.align}
                              onClick={() => {
                                setUniqueCode(UniqueCode);
                              }}
                            >
                              {isFetching ? (
                                <Skeleton />
                              ) : (
                                <Link
                                  className="secondary-link"
                                  key={row.UniqueCode}
                                  onClick={() => {
                                    childRef.current.handleClickOpen();
                                  }}
                                >
                                  {value}
                                </Link>
                              )}
                            </TableCell>
                          ) : (
                            <TableCell
                              key={`column ${index}`}
                              align={column.align}
                            >
                              {isFetching ? <Skeleton /> : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        {!isFetching &&
          <TablePagination
            className="custom-pagination"
            rowsPerPageOptions={[]}
            labelDisplayedRows={defaultLabelDisplayedRows}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={pageNo}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            ActionsComponent={ActionsComponent}
          />}
        </React.Fragment>
      ) : (
        <NoData
          message={
            errorMessage
              ? errorMessage
              : 'As of now, no Homework is available for you. Please come back later.'
          }
        />
      )}
      <PopUpModal
        ref={childRef}
        data={[]}
        header={header}
        body={fetchHomeWorkDetails()}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
      />
    </React.Fragment>
  );
}
